import { Button, Modal } from 'react-bootstrap'
import { sendChatImage } from '../Api/AnonChats/Chats'
import { toast } from 'react-hot-toast'

interface Props {
    image: File | null
    show: boolean
    handleClose: () => void
    playerId: string
    chatId: string
}

export const ShowUploadedImageModal = ({ image, show, handleClose, playerId, chatId }: Props) => {

    if (!image) return null


    const handleSubmitImage = async () => {
        // Check if file is an image
        if (!image.type.startsWith('image/')) {
            toast.error("El archivo seleccionado no es una imagen");
            return;
        }

        // Compress image if larger than 1MB
        let imageToSend = image;
        if (image.size > 1024 * 1024) {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const img = new Image();

            // Create a promise to handle the image loading
            await new Promise((resolve) => {
                img.onload = () => {
                    // Calculate new dimensions while maintaining aspect ratio
                    let width = img.width;
                    let height = img.height;
                    const maxWidth = 1024;
                    const maxHeight = 1024;

                    if (width > height) {
                        if (width > maxWidth) {
                            height = Math.round((height * maxWidth) / width);
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width = Math.round((width * maxHeight) / height);
                            height = maxHeight;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    ctx?.drawImage(img, 0, 0, width, height);

                    // Convert canvas to blob
                    const originalType = image.type;
                    const outputType = originalType === 'image/png' ? 'image/png' : 'image/jpeg';
                    const quality = outputType === 'image/jpeg' ? 0.7 : 1.0;

                    canvas.toBlob((blob) => {
                        if (blob) {
                            imageToSend = new File([blob], image.name, {
                                type: outputType,
                                lastModified: Date.now()
                            });
                        }
                        resolve(null);
                    }, outputType, quality);
                };
                img.src = URL.createObjectURL(image);
            });
        }

        const newFormData = new FormData();
        newFormData.append('image', imageToSend);
        newFormData.append('PlayerId', playerId);
        newFormData.append('chatId', chatId);

        const response = await sendChatImage(newFormData);
        if (response?.success && response?.message) {
            handleClose();
        }
    }

    return (
        <Modal show={show} onHide={handleClose} centered className="bg-load-image px-5">
            <div className='border rounded-3 border-secondary h-100'>
                <Modal.Header closeButton>
                    <Modal.Title>Imagen subida</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex justify-content-center' style={{ maxWidth: '100%', maxHeight: '100%' }}>
                        <img
                            src={URL.createObjectURL(image)}
                            alt="Imagen subida"
                            style={{ maxWidth: '50%', maxHeight: '50%', objectFit: 'contain' }}
                        />
                    </div>
                    <div className='text-start text-secondary mt-2'>
                        <p className='text-xs'>
                            * Es posible que reduzcamos el tamaño y la calidad de la imágen si supera el tamaño máximo permitido (1MB).
                        </p>
                    </div>
                    <div className='d-flex justify-content-end mt-3 gap-2'>
                        <div className='d-flex justify-content-center'>
                            <Button variant="secondary rounded-3" onClick={handleClose}>
                                Cerrar
                            </Button>
                        </div>
                        <Button variant="primary rounded-3" onClick={handleSubmitImage}>
                            Enviar
                        </Button>
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    )
}
